<template>
  <el-aside class="aside-container" width="200px">
    <el-menu :router="true" :default-active="this.$route.path">
      <div v-for="item in menu" :key="item.id">
        <el-submenu
          v-if="item.sonMenu && item.menuStatus === '0'"
          :index="item.menuPath"
        >
          <template slot="title">
            <i :class="`iconfont ${item.menuIcon}`"></i>
            <span>{{ item.menuName }}</span>
          </template>
          <el-menu-item
            :index="child.menuPath"
            v-for="child in item.sonMenu"
            :key="child.id"
          >
            <!-- <i :class="child.menuIcon"></i> -->
            <span slot="title">{{ child.menuName }}</span>
          </el-menu-item>
        </el-submenu>
        <el-menu-item
          :index="item.menuPath"
          v-if="!item.sonMenu && item.menuStatus === '0'"
        >
          <i :class="`iconfont ${item.menuIcon}`"></i>
          <span slot="title">{{ item.menuName }}</span>
        </el-menu-item>
      </div>
    </el-menu>
  </el-aside>
</template>
<script>
import { mapState } from "vuex";
export default {
  created() {
    this.menu = this.user.menu;
  },
  computed: {
    ...mapState("loginUser", ["user"]),
  },
};
</script>

<style lang="less" scoped>
@import "~@/style/iconfont.css";

.el-menu-item,
.el-submenu__title {
  height: 48px;
  line-height: 48px;
  margin: 10px 0;
}

.aside-container {
  z-index: 9;
  background-color: #fff;
  box-shadow: 2px 0px 16px 0px rgba(43, 87, 134, 0.1);

  .el-menu {
    border: 0 solid;
    margin-top: 50px;
  }

  .el-submenu.is-active {
    ::v-deep .el-submenu__title {
      font-weight: bold;
    }
  }

  .el-submenu .el-menu-item span {
    padding-left: 10px;
  }

  .el-menu-item.is-active {
    background: #f1f2f8;
    font-weight: bold;
  }

  .el-menu-item i,
  .el-submenu__title i {
    display: inline-block;
    margin-right: 10px;
    color: #fff;
    font-size: 14px;
    line-height: 24px;
    text-align: center;
    border-radius: 34px;
    width: 24px;
    height: 24px;
  }

  .icon-release {
    background: #40cd58;
  }

  .icon-queue {
    background: #6f5ff4;
  }

  .icon-history {
    background: #ff563b;
  }

  .icon-empower {
    background: #ffb400;
  }

  .icon-user-l {
    background: #5f8bff;
  }

  .icon-user-list {
    background: #4bc383;
  }

  .icon-xian {
    background: #11b2b8;
  }
}
</style>
